import React, { useEffect, useState } from 'react';
import { NavLink } from 'react-router-dom';
import { FiMenu, FiX, FiHome, FiFileText, FiCode, FiFolder } from 'react-icons/fi';
import Skeleton from '../ui/Skeleton';
import { getAvatarUrl } from '../../services/avatarService';
import './Header.css';

const navigationLinks = [
  { path: '/', label: 'Accueil', end: true, icon: <FiHome /> },
  { path: '/resume', label: 'CV', icon: <FiFileText /> },
  { path: '/skills', label: 'Compétences', icon: <FiCode /> },
  { path: '/projects', label: 'Projets', icon: <FiFolder /> },
];

function Header() {
  const [avatarUrl, setAvatarUrl] = useState(null);
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  useEffect(() => {
    let mounted = true;
    async function fetchAvatar() {
      const url = await getAvatarUrl();
      if (mounted) setAvatarUrl(url);
    }
    fetchAvatar();
    return () => { mounted = false; };
  }, []);

  return (
    <header className="header">
      <div className="container">
        <div className="header-content">

          {/* LOGO - Aligné à gauche */}
          <NavLink to="/" className="header-logo" onClick={() => setIsMenuOpen(false)}>
            <div className="header-icon">
              <svg width="32" height="32" viewBox="0 0 32 32" fill="none">
                <defs>
                  <linearGradient id="logoGradient" x1="0" y1="0" x2="32" y2="32" gradientUnits="userSpaceOnUse">
                    <stop offset="0" stopColor="#2563eb" />
                    <stop offset="1" stopColor="#7c3aed" />
                  </linearGradient>
                </defs>
                <rect x="1" y="1" width="30" height="30" rx="8" fill="url(#logoGradient)"/>
                <text x="16" y="21" fontFamily="var(--font-family-mono)" fontSize="12" fontWeight="bold" textAnchor="middle" fill="white">TY</text>
              </svg>
            </div>
          </NavLink>

          {/* NAVIGATION - Alignée à droite */}
          <nav className="main-nav">
            <div className="nav-links">
              {navigationLinks.map(link => (
                <NavLink key={link.path} to={link.path} end={link.end} className="nav-link">
                  <span className="nav-link-icon">{link.icon}</span>
                  {link.label}
                </NavLink>
              ))}
            </div>

            <div className="nav-actions">
              <div className="avatar-container">
                {avatarUrl ? (
                  <img src={avatarUrl} alt="T. Yvars" className="avatar" />
                ) : (
                  <Skeleton variant="avatar" width={32} height={32} className="avatar-skeleton" />
                )}
              </div>
            </div>
          </nav>

          {/* MENU MOBILE */}
          <button
            className="menu-toggle"
            onClick={() => setIsMenuOpen(open => !open)}
            aria-label="Menu"
            aria-expanded={isMenuOpen}
          >
            {isMenuOpen ? <FiX /> : <FiMenu />}
          </button>
        </div>

        {isMenuOpen && (
          <nav className="mobile-nav">
            {navigationLinks.map(link => (
              <NavLink
                key={link.path}
                to={link.path}
                end={link.end}
                className="mobile-nav-link"
                onClick={() => setIsMenuOpen(false)}
              >
                <span className="mobile-nav-icon">{link.icon}</span>
                {link.label}
              </NavLink>
            ))}
          </nav>
        )}
      </div>
    </header>
  );
}

export default Header;